module.exports = __webpack_public_path__ + "static/media/nullify.18c5219d.svg";